"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.App = App;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var entry_1 = require("./entry");
function App() {
    return ((0, jsx_runtime_1.jsxs)(react_1.HeroUIProvider, { children: [(0, jsx_runtime_1.jsx)(react_1.ToastProvider, { disableAnimation: true, placement: "top-right" }), (0, jsx_runtime_1.jsx)(entry_1.Entry, {})] }));
}
